import { Component } from '@angular/core';
import { TranslationService } from '../../../core/services/translation.service';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss']
})
export class LangSwitcherComponent {
  locales = [
    { code: 'en', label: 'EN', flag: '🇬🇧' },
    { code: 'es', label: 'ES', flag: '🇪🇸' },
    { code: 'pt', label: 'PT', flag: '🇵🇹' },
    { code: 'fr', label: 'FR', flag: '🇫🇷' },
    { code: 'de', label: 'DE', flag: '🇩🇪' },
    { code: 'it', label: 'IT', flag: '🇮🇹' },
    { code: 'el', label: 'EL', flag: '🇬🇷' },
    { code: 'uk', label: 'UK', flag: '🇺🇦' }
  ];

  expanded = false;
  current = 'en';
  dialogOpen = false;
  showSelected = true;

  constructor(private translations: TranslationService) {
    this.current = this.translations.locale || 'en';
  }

  changeLocale(locale: string): void {
    this.translations.setLocale(locale as any);
    this.current = locale;
    this.expanded = false;
    this.dialogOpen = false;
    this.showSelected = false;
    this.scheduleShowSelected();
  }

  get selected() {
    return this.locales.find(l => l.code === this.current);
  }

  toggle(): void {
    if (this.isMobile()) {
      this.dialogOpen = true;
      this.expanded = false;
      this.showSelected = true;
    } else {
      if (!this.expanded) {
        this.showSelected = false;
        this.expanded = true;
      } else {
        this.expanded = false;
        this.scheduleShowSelected();
      }
    }
  }

  closeDialog(): void {
    this.dialogOpen = false;
  }

  private isMobile(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 768;
  }

  private scheduleShowSelected(): void {
    setTimeout(() => {
      this.showSelected = true;
    }, 100);
  }
}
